class FullScreen
{
    constructor(el, shouldActivate = null) {
        this.elem = el

        window.addEventListener("orientationchange", (event) => {
            if ((!shouldActivate || shouldActivate()) && this.isLandscape()) {
                this.becomeFullscreen();
            } else {
                this.exitFullscreen();
            }
        })
    }

    becomeFullscreen() {
        if (this.elem.requestFullscreen) {
            this.elem.requestFullscreen();
        } else if (this.elem.mozRequestFullScreen) {
            /* Firefox */
            this.elem.mozRequestFullScreen();
        } else if (this.elem.webkitRequestFullscreen) {
            /* Chrome, Safari and Opera */
            this.elem.webkitRequestFullscreen();
        } else if (this.elem.msRequestFullscreen) {
            /* IE/Edge */
            this.elem.msRequestFullscreen();
        }
    }

    exitFullscreen() {
        try {
            document.exitFullscreen().catch(() => {});
        } catch (err) {}
    }

    isLandscape() {
        var orientation = (screen.orientation || {}).type || screen.mozOrientation || screen.msOrientation;

        return ["landscape-primary", "landscape-secondary"].indexOf(orientation) != -1
    }
}

export default FullScreen